module.exports = __webpack_public_path__ + "static/media/rps3.b5059abc.gif";